import React, { useEffect, useRef, useState } from "react";
import {
  documentUploadDrive,
  getEnvelopeSenderList,
  userEnvelopeDownloadData,
} from "../../../../services/CommonService";
import { useNavigate } from "react-router-dom";
import Utils from "../../../../utils";
import Pagination from "react-js-pagination";
import DeleteEnvelope from "./DeleteEnvelope";
import TransferEnvelope from "./TransferEnvelope";
import CopyEnvelope from "./CopyEnvelope";
import { toast } from "react-toastify";
import DownloadDataDoc from "./ViewEnvelope/DownloadDataDoc";
import useDocumentCounts from "./useDocumentCounts";
import "./envelopeTabs.css";
import FilterBar from "./components/FilterBar";

const lengths = Utils.tableShowLengths();

function CompletedManageEnvelope() {
  const navigate = useNavigate();
  const userData = Utils.loginUserData();
  const userEmail = userData?.email || "";

  const [senderList, setSenderList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [totalData, setTotalData] = useState(0);
  const [downloadDataList, setDownloadDataList] = useState({});
  const [dataParams, setDataParams] = useState({
    limit: lengths[0],
    page: 1,
    status_id: 2,
    search: "",
    sender_id: "",
    envelope_id: "",
    order_column: "created_at",
    order_by: false,
    is_effect: false,
  });
  const [deleteEnvelope, setDeleteEnvelope] = useState({ id: 0, name: "" });
  const [copyEnvelope, setCopyEnvelope] = useState(0);
  const [selectedOption, setSelectedOption] = useState('Completed');
  
  const hasFetched = useRef(false);
  const DownloadDataModelRef = useRef(null);

  const {
    counts: { totalFiles, totalInProgress, totalDraft, totalCompleted },
    envelopeList,
    envelopeProcess,
    loading,
    setLoading,
  } = useDocumentCounts({
    userEmail,
    selectedUserId,
    dataParams,
    userId: selectedUserId,
  });

  useEffect(() => {
    setTotalData(totalCompleted);
  }, [totalCompleted]);

  useEffect(() => {
    const fetchSenderList = async () => {
      if (hasFetched.current) return;
      hasFetched.current = true;

      try {
        const response = await getEnvelopeSenderList();
        const senderData = response?.data?.data || [];
        setSenderList(senderData);
        setSelectedUserId((prev) => prev || (senderData[0]?.id || null));
      } catch (error) {
        console.error("Error fetching sender list:", error);
      }
    };

    fetchSenderList();
  }, []);

  const handleData = (e, type) => {
    let params = { ...dataParams };
    if (type === "pagination") {
      params.page = e;
    } else if (type === "sender") {
      params.sender_id = e.target.value;
      setSelectedUserId(e.target.value);
    } else if (type === "envelope") {
      params.envelope_id = e.target.value;
    } else if (type === "search") {
      params.search = e.target.value;
    } else if (type === "limit") {
      params.limit = parseInt(e.target.value);
    }
    setDataParams(params);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
       let params = { ...dataParams };
       params.search = e.target.value;
       setDataParams(params);
    }
  };

  const onCopyEnvelope = (data) => {
    setCopyEnvelope(data.id);
  };

  const onDeleteEnvelope = (data) => {
    setDeleteEnvelope({ id: data.id, name: data.envelope_name });
  };

  const onTransferEnvelope = (data) => {
    setDeleteEnvelope({ id: data.id, name: data.envelope_name });
  };

  const handleManageView = (e, data) => {
    navigate("/manage/" + data.uuid);
  };

  const handleCreateSort = (e, column) => {
    e.preventDefault();
    let params = { ...dataParams };
    params.order_column = column;
    params.order_by = !params.order_by;
    params.page = 1;
    setDataParams(params);
  };

  const handleSendCloud = (e, data) => {
    e.preventDefault();
    setLoading(true);
    let obj = { id: data.id };
    documentUploadDrive(obj)
      .then((response) => {
        setLoading(false);
        toast.success(response.data.message);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setLoading(false);
      });
  };

  const downloadAllFileForm = (e, data) => {
    e.preventDefault();
    setLoading(true);
    let obj = { envelope_id: parseInt(data.id) };
    userEnvelopeDownloadData(obj)
      .then((res) => {
        setDownloadDataList(res.data.data);
        DownloadDataModelRef?.current.click();
        setLoading(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setLoading(false);
      });
  };

  const highlightText = (text, search) => {
    if (!search) return text;
    const regex = new RegExp(`(${search})`, "gi");
    const parts = text.split(regex);
    return parts.map((part, i) =>
      regex.test(part) ? <mark key={i}>{part}</mark> : part
    );
  };

  const dropdownOptions = [
    { label: "In Progress", color: "partial", badge: totalInProgress, route: "/manage" },
    { label: "Draft", color: "unpaid", badge: totalDraft, route: "/manage/draft" },
    { label: "Completed", color: "paid", badge: totalCompleted, route: "/manage/completed" },
    { label: "Contract Files", color: "files", route: "/manage/files" },
  ];

  const handleDropdownOptionClick = (option) => {
    setSelectedOption(option.label);
    navigate(option.route);
  };

  const handleManageNegotiation = () => {
    navigate("/manage/negotiation");
  };

  const handleManageSleeve = () => {
    navigate("/manage/completed"); 
  };

  const createContract = () => { 
    navigate("/client-portal/sleeve");
  };

  return (
    <>
      {loading && (
        <div className="page-loading">
          <img src="/images/loader.gif" alt="loader" />
        </div>
      )}
      <section
        className="main_wrapper section-bg-color"
        style={{ minHeight: "calc(100vh - 0vh)" }}
      >
        <div className="custom_container">
          
          <FilterBar
            searchText={dataParams.search}
            setSearchText={(val) => handleData({ target: { value: val } }, "search")}
            handleKeyDown={handleSearchKeyDown}
            handleManageSleeve={handleManageSleeve}
            handleManageNegotiation={handleManageNegotiation}
            createContract={createContract}
            selectedOption={selectedOption}
            dropdownOptions={dropdownOptions}
            handleDropdownOptionClick={handleDropdownOptionClick}
            tags={[]}
            activeTab="contract"
          />

          {senderList.length > 1 && (
            <div className="d-flex justify-content-end mb-2">
                <select
                className="filter-select"
                value={dataParams.sender_id}
                onChange={(e) => handleData(e, "sender")}
                title="Select a user to filter Contract"
                style={{maxWidth: '200px'}}
                >
                <option value="">All Users</option>
                {senderList.map((item, index) => (
                    <option key={index} value={item.id}>
                    {item.first_name + " " + item.last_name}
                    </option>
                ))}
                </select>
            </div>
          )}

          {/* Modern Table UI */}
          <div className="modern-table-container" style={{ minHeight: "300px" }}   id="Inprogress-detail"
            role="tabpanel"
            aria-labelledby="Inprogress">
            <div className="table-wrapper">
              <table className="modern-table">
                <thead>
                  <tr>
                    <th onClick={(e) => handleCreateSort(e, "created_at")} className="sortable-header">
                      <div className="th-content">
                        <span>Created</span>
                        {dataParams.order_column === "created_at" ? (
                          dataParams.order_by ? <i className="bi bi-arrow-up" /> : <i className="bi bi-arrow-down" />
                        ) : (
                          <i className="bi bi-arrow-down-up opacity-50" />
                        )}
                      </div>
                    </th>

                    <th onClick={(e) => handleCreateSort(e, "envelope_name")} className="sortable-header">
                      <div className="th-content">
                        <span>Contract Name</span> 
                        {dataParams.order_column === "envelope_name" ? (
                          dataParams.order_by ? <i className="bi bi-arrow-up" /> : <i className="bi bi-arrow-down" />
                        ) : (
                          <i className="bi bi-arrow-down-up opacity-50" />
                        )}
                      </div>
                    </th>

                    <th onClick={(e) => handleCreateSort(e, "recipient_names")} className="sortable-header">
                      <div className="th-content">
                        <span>Collaborators</span>
                        {dataParams.order_column === "recipient_names" ? (
                          dataParams.order_by ? <i className="bi bi-arrow-up" /> : <i className="bi bi-arrow-down" />
                        ) : (
                          <i className="bi bi-arrow-down-up opacity-50" />
                        )}
                      </div>
                    </th>

                    <th onClick={(e) => handleCreateSort(e, "due_date")} className="sortable-header">
                      <div className="th-content">
                        <span>Due Date</span>
                        {dataParams.order_column === "due_date" ? (
                          dataParams.order_by ? <i className="bi bi-arrow-up" /> : <i className="bi bi-arrow-down" />
                        ) : (
                          <i className="bi bi-arrow-down-up opacity-50" />
                        )}
                      </div>
                    </th>

                    <th onClick={(e) => handleCreateSort(e, "sender_name")} className="sortable-header">
                      <div className="th-content">
                        <span>User</span>
                        {dataParams.order_column === "sender_name" ? (
                          dataParams.order_by ? <i className="bi bi-arrow-up" /> : <i className="bi bi-arrow-down" />
                        ) : (
                          <i className="bi bi-arrow-down-up opacity-50" />
                        )}
                      </div>
                    </th>

                    <th>
                      <div className="th-content">
                        <span>Download</span>
                      </div>
                    </th>

                    <th>
                      <div className="th-content">
                        <span>Send to Cloud</span>
                      </div>
                    </th>

                    <th className="action-column">
                      <div className="th-content">
                        <span>Actions</span>
                      </div>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {envelopeList.map((item, index) => (
                    <tr key={index} className="table-row">
                      <td className="table-cell">
                        <span className="cell-content">{item.created_at}</span>
                      </td>

                      <td
                        className="table-cell clickable-cell primary-text"
                        onClick={(e) => handleManageView(e, item)}
                      >
                        {highlightText(item.envelope_name, dataParams.search)}
                      </td>

                      <td className="table-cell">
                        <div className="collaborators-list">
                          {item.recipient_names.map((recipient, r) => (
                            <span key={r} className="collaborator-badge">
                              {recipient}
                            </span>
                          ))}
                        </div>
                      </td>

                      <td className="table-cell">{item.due_date}</td>

                      <td className="table-cell">{item.sender_name}</td>

                      <td className="table-cell action-center">
                        <i
                          className="bi bi-download fontSize action-icon"
                          onClick={(e) => downloadAllFileForm(e, item)}
                        />
                      </td>

                      <td className="table-cell action-center">
                        {item.cloud_sync.split(",").map(Number).some(v => v > 0) &&
                          item.cloud_type.split(",").map(Number).some(v => v > 0) && (
                            <i
                              className="bi bi-cloud-arrow-up fontSize text-primary action-icon"
                              onClick={(e) => handleSendCloud(e, item)}
                            />
                          )}
                      </td>

                      {/* ACTION MENU */}
                      <td className="table-cell action-cell">
                        <div className="action-dropdown">
                          <button
                            className="action-button"
                            type="button"
                            data-bs-toggle="dropdown"
                          >
                            <i className="bi bi-three-dots-vertical"></i>
                          </button>

                          <ul className="dropdown-menu dropdown-menu-end modern-dropdown">
                            <li>
                              <button
                                className="dropdown-item"
                                data-bs-toggle="modal"
                                data-bs-target="#CopyEnvelope"
                                onClick={() => onCopyEnvelope(item)}
                              >
                                <i className="bi bi-files" />
                                <span>Duplicate Contract</span>
                              </button>
                            </li>

                            <li>
                              <button
                                className="dropdown-item"
                                data-bs-toggle="modal"
                                data-bs-target="#transferEnvelope"
                                onClick={() => onTransferEnvelope(item)}
                              >
                                <i className="bi bi-arrow-left-right" />
                                <span>Transfer Contract</span>
                              </button>
                            </li>
                            <li>
                              <button
                                className="dropdown-item danger-item"
                                data-bs-toggle="modal"
                                data-bs-target="#DeleteEnvelope"
                                onClick={() => onDeleteEnvelope(item)}
                              >
                                <i className="bi bi-trash" />
                                <span>Delete Contract</span>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  ))}

                  {envelopeList.length === 0 && (
                    <tr>
                      <td colSpan={8}>
                        <div className="empty-state-content">
                          <div className="empty-state-icon">
                            <i className="bi bi-inbox"></i>
                          </div>
                          <h5 className="empty-state-text">{envelopeProcess}</h5>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          {totalData > dataParams.limit && (
            <div className="table_footer_wrap">
              <div className="d-flex align-items-center mb-4">
                <span className="me-2 text-white">Show</span>
                <select
                  className="form-select"
                  value={dataParams.limit}
                  style={{ width: "80px" }}
                  onChange={(e) => handleData(e, "limit")}
                  aria-label="Default select example"
                >
                  {lengths &&
                    lengths.map((item, i) => (
                      <option value={item} key={i}>
                        {item}
                      </option>
                    ))}
                </select>
              </div>
              <div className="pagination mb-4">
                <Pagination
                  activePage={dataParams.page}
                  itemsCountPerPage={dataParams.limit}
                  totalItemsCount={totalData}
                  pageRangeDisplayed={5}
                  onChange={(e) => handleData(e, "pagination")}
                />
              </div>
            </div>
          )}
        </div>

        <DeleteEnvelope
          deleteEnvelope={deleteEnvelope}
          setDeleteEnvelope={setDeleteEnvelope}
          setLoading={setLoading}
          dataParams={dataParams}
          setDataParams={setDataParams}
        />

        <div
          ref={DownloadDataModelRef}
          data-bs-toggle="offcanvas"
          data-bs-target="#DownloadDataDoc"
          aria-controls="DownloadDataDoc"
        />
        <DownloadDataDoc
          setLoading={setLoading}
          downloadDataList={downloadDataList}
          setDownloadDataList={setDownloadDataList}
        />

        <TransferEnvelope
          deleteEnvelope={deleteEnvelope}
          setDeleteEnvelope={setDeleteEnvelope}
          senderList={senderList}
          setLoading={setLoading}
          dataParams={dataParams}
          setDataParams={setDataParams}
        />

        <CopyEnvelope
          copyEnvelope={copyEnvelope}
          setCopyEnvelope={setCopyEnvelope}
          setLoading={setLoading}
        />
      </section>
    </>
  );
}

export default CompletedManageEnvelope;